<template>
  <SuccessPage
    :title="`${$t('i18n_reset')}${$t('i18n_password')}`"
    :on-confirm="_handleConfirm"
    :confirm-text="$t('i18n_define')"
  >
    <p>
      {{ $t('i18n_reset_password_success') }}
    </p>
  </SuccessPage>
</template>

<script>
import SuccessPage from './component/SuccessPage'

export default {
  name: 'PasswordResetSuccess',
  components: { SuccessPage },
  methods: {
    async _handleConfirm() {
      this.$authProvider.initToken(this.$route.params)
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>
